/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useContext, useEffect, useState} from 'react';
import {AddPlayers, EditPlayers} from '..';
import {Admin, Teams} from '../../../utils/api';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {
  DeleteContainer,
  ManageHeaderContent,
  ManageHeaderLeft,
  ManageHeaderWrapper,
  MembershipSection,
  MembershipMessage,
  MembershipButton,
  CloseModalButton,
  ModalBackground,
  MembershipAvailable,
} from './styles';
import {
  InputComponent,
  PowerDropdown,
  WhiteContainer,
  TableManagePlayers,
  InfoBanner,
  Modal,
  NavbarButton,
  LargeButton,
  Loader,
  ToolTip,
} from '../../../components';
import {ARMcontext} from '../../../utils/context/context';
import PaginationControls from '../../../components/PaginationControls/PaginationControls';
import { wait } from '../../../utils/helpers/wait';
import { MessagesConstants } from '../../../utils/constants/messages';
import { DELAY_TIME } from '../../../utils/constants/time';

const DefaultPlayers = [
  {title: 'All players'},
  {title: 'Pitchers'},
  {title: 'Catchers'},
];
export default ({teamMemo, modal, useModal}) => {
  const [loadingMembershipAvailable, setLoadingMembershipAvailable] = useState(true);
  const [loadingInvitation, setLoadingInvitation] = useState(true);
  const [playerInvitations, usePlayerInvitations] = useState<Array<object | any> | any>([]);
  const [selectedPlayers, useSelectedPlayers] = useState<Array<object | any> | any>([]);
  const [playerGeneralInfo, usePlayerInfo] = useState<Array<object | any> | any>([]);
  const [membershipInfo, useMembershipInfo] = useState<Array<object | any> | any>([]);
  const [defaultPlayers, useDefaultPlayers] = useState<Array<any>>(DefaultPlayers);
  const [isLoadingDelete, setLoadingDelete] = useState<boolean>(false);
  const [players, usePlayers] = useState<any>(defaultPlayers[0]);
  const {HandleToastMessage} = useContext(ARMcontext);
  const [team, useTeam] = useState<any>(teamMemo[0]);
  const [counter, useCounter] = useState<number>(0);
  const filterPlayer = useInputValue('', 'search');
  const [debouncedFilterValue, setDebouncedFilterValue] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [remove, useRemove] = useState(false);
  const [check, useCheck] = useState(false);
  const [edit, useEdit] = useState(false);
  const [loadingBulk, setLoadingBulk] = useState(true);
  const [isHovering, setIsHovering] = useState(false);
  const [textButton, setTextButton] = useState('');
  const {user} = React.useContext(ARMcontext);
  const ADMIN = new Admin();
  const TEAMS = new Teams();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    recordsPerPage: 20
  });

  const debounce = useCallback((func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  }, []);

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      setDebouncedFilterValue(value);
    }, 300),
    []
  );

  useEffect(() => {
    debouncedSearch(filterPlayer.value);
  }, [filterPlayer.value, debouncedSearch]);


  const handleSort = useCallback((key) => {
    setSortConfig(prevSort => ({
      key,
      direction: prevSort.key === key && prevSort.direction === 'asc' ? 'desc' : 'asc',
    }));
  }, []);

  useEffect(() => {
    FetchPlayerInvitation();
    FetchMembershipAvailablity();
  }, [pagination.currentPage, pagination.recordsPerPage, sortConfig, team, players.title, debouncedFilterValue]);

  useEffect(() => {
    if (team) {
      useTeam(prev => {
        prev.name = 'All players';
        return prev;
      });
    }
  }, [])

  useEffect(() => {
    useCounter(playerInvitations.reduce((total, el) => (el.checked ? total + 1 : total), 0));
    BuildPlayersFilter();
  }, [playerInvitations]);

  useEffect(()=>{
    if(loadingBulk){
      FetchBulkProcessing();
    }
  }, [loadingBulk])

  const DefaultInfo = [
    {number: playerGeneralInfo?.totalPlayers || 0, text: 'Total Players'},
    {number: playerGeneralInfo?.activePlayers || 0, text: 'Active Players'},
    {number: playerGeneralInfo?.inactivePlayers || 0, text: 'Inactive Players'},
    {number: playerGeneralInfo?.pendingInvites || 0, text: 'Pending Players'},
  ];

  const MembershipInfo = [{number: membershipInfo?.yearlyPrepay || 0}];

  const playersTableHead = [
    {
      title: 'PLAYERS',
      colSpan: '1',
      examType: ['firstName'],
    },
    {
      title: 'EMAIL',
      colSpan: '1',
      examType: ['email'],
    },
    {
      title: 'TEAM',
      colSpan: '1',
      examType: ['team', 0, 'name'],
    },
    {
      title: 'STATUS',
      colSpan: '1',
      examType: ['status'],
    },
    {
      title: 'SUBSCRIPTION',
      colSpan: '1',
      examType: ['invitationType'],
    },
    {
      title: 'START DATE',
      colSpan: '1',
      examType: ['sponsorshipStartDate'],
    },
    {
      title: 'EXPIRATION DATE',
      colSpan: '1',
      examType: ['sponsorshipEndDate'],
    },
    {
      title: 'INVITATION SENT',
      colSpan: '1',
      examType: ['createdAt'],
    },
  ];

  const INVITATION_TYPES = {
    REQUEST: 'Request',
  };

  async function FetchPlayerInvitation(): Promise<void> {
    setLoadingInvitation(true);
    const resPlayerInvitation = await ADMIN.GetAdminPlayersInvitation(
      team?._id,
      players.title,
      debouncedFilterValue,
      pagination.currentPage,
      pagination.recordsPerPage,
      sortConfig.key,
      sortConfig.direction,
    );

    const responsePlayersInfo = await ADMIN.GetAdminPlayersInfo()

    setLoadingInvitation(false);
    if (resPlayerInvitation.status) {
      usePlayerInvitations(
        [...resPlayerInvitation.data.response].map(elem => {
          let payType = elem.invitationType;
          if (payType === INVITATION_TYPES.REQUEST) {
            payType = 'Invited';
          }
          return {...elem, payment: payType};
        }),
      );
      usePlayerInfo(responsePlayersInfo.data.dataCount);
      setPagination(prev => ({
        ...prev,
        currentPage: resPlayerInvitation.data.currentPage,
        totalPages: resPlayerInvitation.data.totalPages,
        totalItems: resPlayerInvitation.data.totalItems,
      }));
    } else {
      HandleToastMessage(resPlayerInvitation?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingInvitation(false);
  }

  async function FetchMembershipAvailablity() {
    const resMembershipAvailablity = await ADMIN.GetMembershipAvailability();
    if (resMembershipAvailablity.status) {
      useMembershipInfo(resMembershipAvailablity.data.types);
    } else {
      HandleToastMessage(resMembershipAvailablity?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingMembershipAvailable(false);
  }

  async function FetchBulkProcessing() {
    await wait(DELAY_TIME.initialTime);
    const res = await ADMIN.GetBulkProcessing();
    if (res.data.statusCode === 200 || res.data.statusCode === 201 || res.data.statusCode === 202) {
      setLoadingBulk(res.data.bulkProcessing || false);
      if(res.data.bulkProcessing){
        setTextButton(MessagesConstants.BULK_UPLOAD.ADD_PLAYER_DISABLED_BUTTON);
        await wait(DELAY_TIME.nextCallTime);
        await FetchBulkProcessing()
      } else {
        setTextButton('');
      }
    }
  }

  function ChangePlayers(selectedOption: any) {
    usePlayers(selectedOption);
    setPagination(prev => ({
      ...prev,
      currentPage: 1,
    }));
  }

  function BuildPlayersFilter() {

    const playerCounts = [
      {title: 'All players', lenght: playerGeneralInfo?.totalPlayers?.toString()},
      {title: 'Pitchers', lenght: playerGeneralInfo?.positionCounts?.pitcher?.toString()},
      {title: 'Catchers', lenght: playerGeneralInfo?.positionCounts?.catcher?.toString()},
      {title: 'Infielders', lenght: playerGeneralInfo?.positionCounts?.infielder?.toString()},
      {title: 'Outfielders', lenght: playerGeneralInfo?.positionCounts?.outfielder?.toString()},
    ];
    useDefaultPlayers(playerCounts);
  }

  async function handleRequest(id, request) {
    if (user?.membership?.membershipStatus === 'OK') {
      const response = await ADMIN.sendResponseStatus(id, request);
      if (response.status) {
        FetchPlayerInvitation();
      } else {
        HandleToastMessage('An error ocurred', true, 2500, 'error');
      }
    } else {
      useModal(true);
    }
  }

  function HandleSendInvitationPlayer(value = true, makeRequest = false) {
    useModal(value);
    if (makeRequest) {
      FetchPlayerInvitation();
    }
  }

  function ChangeTeam(selectedTeam: any) {
    useTeam(selectedTeam);
    setPagination(prev => ({
      ...prev,
      currentPage: 1,
    }));

    BuildPlayersFilter();
  }

  function HandleAllPlayers(check: any) {
    useCheck(check);
    usePlayerInvitations([
      ...playerInvitations.map(el => {
        if (team._id === undefined) {
          el['checked'] = check;
        }
        el.team?.map(item => {
          if (item._id === team._id) {
            el['checked'] = check;
          }

          return el;
        });

        return el;
      }),
    ]);
  }

  function HandleOnePlayer(check: any) {
    usePlayerInvitations([
      ...playerInvitations.map(el => {
        if (check._id === el._id) {
          el['checked'] = !el?.checked || false;
        }
        return el;
      }),
    ]);
  }

  function HandleRemove(value = true) {
    useRemove(value);
    useSelectedPlayers(JSON.parse(JSON.stringify(playerInvitations.filter(el => el['checked']))));

    if (!value) {
      setLoadingInvitation(true);
      FetchPlayerInvitation();
    }
  }

  function HandleEdit(value = true, makeRequest = false) {
    useEdit(value);
    useSelectedPlayers(JSON.parse(JSON.stringify(playerInvitations.filter(el => el['checked']))));

    if (makeRequest) {
      FetchPlayerInvitation();
    }
  }

  // function checkTeams(team, teams): Boolean {
  //   let isInMyTeam: Boolean = false;
  //   teams.map(item => {
  //     if (item._id === team) {
  //       isInMyTeam = true;
  //     }
  //     return true;
  //   });

  //   return isInMyTeam;
  // }

  function RemovePLayers() {
    setLoadingDelete(true);
    const playersIDs = selectedPlayers.map(el => el._id);
    const results = playersIDs.map(async el => {
      return await TEAMS.DeletePlayerInvitation(el);
    });
    Promise.all(results).then(() => {
      HandleToastMessage('Invitations deleted', true, 2500, 'success');
      HandleRemove(false);
      setLoadingDelete(false);
    });
  }

  function managePaymentButton(handler) {
    handler(false);
    window.open('https://armcare.com/my-account/payment-methods/', '_blank');
  }

  return (
    <>
      <WhiteContainer dataCy="managePlayers-container">
        <MembershipAvailable>
          <InfoBanner
            data={MembershipInfo}
            title={'TOTAL PREMIUM YEARLY SPONSORSHIP AVAILABLE'}
            itemWidth={'80px'}
            lineBetweenTitle={false}
          />
          {
            loadingBulk ? (
              <div onMouseEnter={() => setIsHovering(true)} onMouseLeave={()=>setIsHovering(false)}>

                <LargeButton
                  title="ADD PLAYERS"
                  disabled={true}
                  lColor="var(--SecondaryBlue);"
                  rColor="var(--PrimaryBlue);"
                  icon="plus"
                  responsive="735px"
                  xMargin="0px 0px 0px 20px"
                  data-tooltip-id="my-tooltip" data-tooltip-content="Hello world!"
                />
                {
                  (isHovering && textButton) &&
                    <ToolTip theme={'dark'} title={textButton} text=''/>
                }
              </div>
            ) : (
                <LargeButton
                  title="ADD PLAYERS"
                  lColor="var(--SecondaryBlue);"
                  rColor="var(--PrimaryBlue);"
                  icon="plus"
                  responsive="735px"
                  callback={HandleSendInvitationPlayer}
                  xMargin="0px 0px 0px 20px"
                />
            )
          }
        </MembershipAvailable>
        {!Boolean(counter) ? (
          <ManageHeaderContent>
            <ManageHeaderLeft>
              <ManageHeaderWrapper>
                <PowerDropdown
                  primaryTitle={team?.name}
                  badge={team?.initials || team?.badge}
                  picture={team?.picture}
                  colorBadge={team?.color}
                  search={true}
                  onClick={ChangeTeam}
                  dataArray={teamMemo}
                  mPadding="4px 0 4px 10px"
                  mWidth="308px"
                />
              </ManageHeaderWrapper>
              <ManageHeaderWrapper data-cy="managePlayers-container-players">
                <PowerDropdown
                  primaryTitle={players.title}
                  visibleLenght={players.lenght}
                  search={false}
                  onClick={ChangePlayers}
                  dataArray={defaultPlayers}
                  mPadding="4px 0 4px 10px"
                />
              </ManageHeaderWrapper>
              <ManageHeaderWrapper>
                <InputComponent responsive="700px" dynamicSearch={filterPlayer} animateWidth="80%" placeholder="Search players" />
              </ManageHeaderWrapper>
            </ManageHeaderLeft>

            <InfoBanner data={DefaultInfo} />
          </ManageHeaderContent>
        ) : (
          <ManageHeaderContent data-cy="managePlayers-counter-container">
            <ManageHeaderLeft>
              <NavbarButton xmargin="4px" counter={counter} title="" icon="checkbox" onClick={() => HandleAllPlayers(false)} />
              <NavbarButton xmargin="4px" text="Edit player" title="" icon="save" onClick={HandleEdit} />
              <NavbarButton xmargin="4px" text="Remove" title="" icon="trash" onClick={HandleRemove} />
            </ManageHeaderLeft>
          </ManageHeaderContent>
        )}

        <div style={{overflowX: 'auto'}}>
          {loadingInvitation || loadingMembershipAvailable ? (
            <Loader height="90px" />
          ) : (
            <TableManagePlayers
              minWidth="800px"
              dataTableHead={playersTableHead}
              dataMainHead={[]}
              dataTableContent={playerInvitations}
              filter={filterPlayer}
              handleRequest={handleRequest}
              HandleOne={HandleOnePlayer}
              HandleAll={HandleAllPlayers}
              typeOfTable={1}
              individualFilter={players}
              selectedTeam={team?._id}
              check={check}
              useSort={handleSort}
            />
          )}
          <PaginationControls
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            totalItems={pagination.totalItems}
            recordsPerPage={pagination.recordsPerPage}
            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
            onLimitChange={(limit) => setPagination(prev => ({ ...prev, recordsPerPage: limit, currentPage: 1 }))}
          />
        </div>
      </WhiteContainer>
      {modal && (
        <>
          {user?.membership?.membershipStatus === 'OK' && (
            <Modal title="Add Players" margin="10vh auto 200px auto" dataCy="addPlayers-modal">
              <AddPlayers handleView={HandleSendInvitationPlayer} teamMemo={teamMemo}  setLoadingBulk={setLoadingBulk} />
            </Modal>
          )}
          {user?.membership?.membershipStatus !== 'OK' && (
            <ModalBackground onClick={() => useModal(false)}>
              <Modal title="Payment Failed" margin="10vh auto 200px auto" padding={'20px 40px 15px 40px'}>
                <MembershipSection>
                  <MembershipMessage>
                    {user?.role === 'org-admin' && 'You must pay your monthly fees in order to invite players'}
                    {user?.role === 'coach' &&
                      'The account owner  must pay the monthly fees in order to invite players or accept request.'}
                  </MembershipMessage>
                  <MembershipButton>
                    {user?.role === 'org-admin' && (
                      <LargeButton
                        callback={() => managePaymentButton(useModal)}
                        rColor="#FF2608"
                        lColor="#E12107"
                        title="PAY MEMBERSHIP"
                        fColor="#FFF"
                        icon="plus"
                        xMargin={'16PX 0PX 21PX 40PX'}
                      />
                    )}
                    {user?.role === 'coach' && <CloseModalButton onClick={() => useModal(false)}>OK</CloseModalButton>}
                  </MembershipButton>
                </MembershipSection>
              </Modal>
            </ModalBackground>
          )}
        </>
      )}
      {remove && (
        <>
          {user?.membership?.membershipStatus === 'OK' && (
            <Modal
              title="Delete"
              padding="20px;"
              margin="30vh auto 200px auto"
              subtitle="Are you sure that you want to remove these players. This will permanently remove them from your organization and you will not be able to see their data">
              <span style={{color: 'red', display: (playerGeneralInfo?.activePlayers === 1) ||
              (playerGeneralInfo?.activePlayers === 1 && playerGeneralInfo?.inactivePlayers.length > 0 ) ||
              (playerGeneralInfo?.activePlayers === 1 && playerGeneralInfo?.pendingInvites.length > 0 )
               ? 'flex' : 'none'}}>
                It is recommended to log in again on the mobile app to update the information.
              </span>
              <DeleteContainer>
                <LargeButton
                  callback={() => HandleRemove(false)}
                  rColor="#ffffff"
                  lColor="#ffffff"
                  title="CANCEL"
                  fColor="#5D6C76"
                  bColor="#F0F0F0"
                  lMargin="0"
                  xMargin="0 10px 0 0"
                />
                {isLoadingDelete ? (
                  <Loader width="145px" height="43px" />
                ) : (
                  <LargeButton callback={RemovePLayers} rColor="#FF3B30" lColor="#E1342A" icon="trash" title="DELETE" />
                )}
              </DeleteContainer>
            </Modal>
          )}
          {user?.membership?.membershipStatus !== 'OK' && (
            <ModalBackground onClick={() => useRemove(false)}>
              <Modal title="Payment Failed" margin="10vh auto 200px auto" padding={'20px 40px 15px 40px'}>
                <MembershipSection>
                  <MembershipMessage>
                    {user?.role === 'org-admin' && 'You must pay your monthly fees in order to invite players'}
                    {user?.role === 'coach' &&
                      'The account owner  must pay the monthly fees in order to invite players or accept request.'}
                  </MembershipMessage>
                  <MembershipButton>
                    {user?.role === 'org-admin' && (
                      <LargeButton
                        callback={() => managePaymentButton(useRemove)}
                        rColor="#FF2608"
                        lColor="#E12107"
                        title="PAY MEMBERSHIP"
                        fColor="#FFF"
                        icon="plus"
                        xMargin={'16PX 0PX 21PX 40PX'}
                      />
                    )}
                    {user?.role === 'coach' && <CloseModalButton onClick={() => useRemove(false)}>OK</CloseModalButton>}
                  </MembershipButton>
                </MembershipSection>
              </Modal>
            </ModalBackground>
          )}
        </>
      )}
      {edit && (
        <>
          {user?.membership?.membershipStatus === 'OK' && (
            <Modal title="Edit Players" margin="10vh auto 200px auto" dataCy="editPlayers-modal">
              <EditPlayers
                teamMemo={teamMemo}
                handleView={HandleEdit}
                selectedPlayers={selectedPlayers}
                useSelectedPlayers={useSelectedPlayers}
              />
            </Modal>
          )}
          {user?.membership?.membershipStatus !== 'OK' && (
            <ModalBackground onClick={() => useEdit(false)}>
              <Modal title="Payment Failed" margin="10vh auto 200px auto" padding={'20px 40px 15px 40px'}>
                <MembershipSection>
                  <MembershipMessage>
                    {user?.role === 'org-admin' && 'You must pay your monthly fees in order to invite players'}
                    {user?.role === 'coach' &&
                      'The account owner  must pay the monthly fees in order to invite players or accept request.'}
                  </MembershipMessage>
                  <MembershipButton>
                    {user?.role === 'org-admin' && (
                      <LargeButton
                        callback={() => managePaymentButton(useEdit)}
                        rColor="#FF2608"
                        lColor="#E12107"
                        title="PAY MEMBERSHIP"
                        fColor="#FFF"
                        icon="plus"
                        xMargin={'16PX 0PX 21PX 40PX'}
                      />
                    )}
                    {user?.role === 'coach' && <CloseModalButton onClick={() => useEdit(false)}>OK</CloseModalButton>}
                  </MembershipButton>
                </MembershipSection>
              </Modal>
            </ModalBackground>
          )}
        </>
      )}
    </>
  );
};
